import { BaseSaleChannel } from "./BaseSaleChannel";

export class TiktokSaleChannel extends BaseSaleChannel
{
    accessToken
    refreshToken

    shop_name
    cipher
    open_id
    tiktokWarehouse


    expired_at
    refresh_before


    constructor(inputparameters) {
        super(inputparameters)

        this._channel_type = 'tiktok'

        const {
          expired_at,
          refresh_before,
        } = inputparameters

        this.expired_at = expired_at
        this.refresh_before = refresh_before

        if (!!this.parameters && !!this.parameters.accessToken) this.accessToken = this.parameters.accessToken

        if (!!this.parameters && !!this.parameters.refreshToken) this.refreshToken = this.parameters.refreshToken

        if (!!this.parameters && !!this.parameters.shop_name) this.shop_name = this.parameters.shop_name

        if (!!this.parameters && !!this.parameters.cipher) this.cipher = this.parameters.cipher

        if (!!this.parameters && !!this.parameters.open_id) this.open_id = this.parameters.open_id

        if (!!this.parameters && !!this.parameters.tiktokWarehouse) this.tiktokWarehouse = this.parameters.tiktokWarehouse

    }

    serialize() {
        return {
            ...super.serialize(),
            ref_id: this.ref_id,
            sellerName: this.sellerName,
            accessToken: this.accessToken,
            refreshToken: this.refreshToken,
            shop_name: this.shop_name,
            cipher: this.cipher,
            open_id: this.open_id,
            expired_at: this.expired_at,
            refresh_before: this.refresh_before,
            tiktokWarehouse: this.tiktokWarehouse
        }
    }
}
